module.exports = __webpack_public_path__ + "img/search_white.76028c98.svg";